export const difficulties = [
  { value: "1", label: "Easy" },
  { value: "2", label: "Intermediate" },
  { value: "3", label: "Pro Homecook" },
  { value: "4", label: "Chef" },
];

export default difficulties;
